import React, { useState } from "react";
import { Card, Text, Spoiler, Textarea, TextInput, Button } from "@mantine/core";
import { motion } from "framer-motion";
import "../Styles/previewTest.css";
import {
  ArrowGuide,
  Article,
  Exchange,
  Exposure,
  InfoCircle,
  TruckDelivery,
} from "tabler-icons-react";

function SelectedCampaign(props) {
  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        style={{ display: "flex", justifyContent: "center", width: "auto" }}
      >
        <div
          style={{
            display: "flex",
            padding: "3vw",
            paddingTop: "0vw",
            width: "auto",
            minWidth: "300px",
            maxWidth: "100%",
            verticalAlign: "top",
          }}
        >
          <Card
            shadow="sm"
            p="lg"
            radius="md"
            withBorder
            style={{ minHeight: "250px" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: 25,
                minWidth: "40vw",
              }}
            >
              <Exposure
                style={{
                  background: "#228BE6",
                  padding: 8,
                  borderRadius: 5,
                }}
                size={28}
                color="white"
              />
              <Text size="15px" ml={10} weight="600">
                About Campaign & {props?.details?.brand}
              </Text>
            </div>
            <Text size={12} ml={40} weight={400} mt={5}>
              {props?.details?.campaign_info}
            </Text>
            <Text size={12} ml={40} weight={400} mt={10}>
              {props?.details?.brand_info}
            </Text>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: 25,
                minWidth: "40vw",
              }}
            >
              <TruckDelivery
                style={{
                  background: "#228BE6",
                  padding: 8,
                  borderRadius: 5,
                }}
                size={28}
                color="white"
              />
              <Text size="15px" ml={10} weight="600">
                You Need To Do This
              </Text>
            </div>
            <Text size={12} ml={40} weight={400}>
              - Perform {props?.details?.number_of_streams} stream(s) with Adly's streaming code in your broadcasting software, tutorial <a href={"https://www.youtube.com/watch?v=g7WSwOtblk0"} target="_blank">here</a>.
            </Text>
            <Text size={12} mt={5} ml={40} weight={400}>
              - Upload all your VODs (link URL) to the streamer platform.
            </Text>
            {/* <Text size={12} ml={40} mt={10} weight={600}>
              Additional
            </Text> */}
            {props?.details?.guidelines.map((guideline) => {
              return (
                <Text size={12} mt={5} ml={40} weight={400}>
                  - {guideline?.guideline}
                </Text>
              );
            })}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: 25,
                minWidth: "40vw",
              }}
            >
              <TruckDelivery
                style={{
                  background: "#228BE6",
                  padding: 8,
                  borderRadius: 5,
                }}
                size={28}
                color="white"
              />
              <Text size="15px" ml={10} weight="600">
                Adly Will Automatically Run
              </Text>
            </div>
            <Text size={12} ml={40} mt={5} weight={600}>
              Stream Overlay - Appears every 10 minutes
            </Text>
            <video
              loop
              style={{
                background: "#00000040",
                borderRadius: "5px",
                marginLeft: 48,
                marginTop: 5,
              }}
              width="235px"
              height="130px"
              autoPlay="autoplay"
            >
              <source src={props?.details?.video_url} type="video/webm" />
            </video>
            <Text size={12} ml={40} mt={10} weight={600}>
              Chat Message - Appears every 10 minutes
            </Text>
            <Text size={12} ml={40} mt={3} weight={400}>
              - {props?.details?.chat_message}
            </Text>
            {props?.details?.brand_lift_question == "" ? (
              ""
            ) : (
              <>
                {" "}
                <Text size={12} ml={40} mt={10} weight={600}>
                  Chat Poll - The poll will appear twice, in the beginning, and the end of the sponsorship.
                </Text>
                <Text size={12} ml={40} mt={3} weight={400}>
                  Question: {props?.details?.brand_lift_question}
                </Text>
                {props?.details?.brand_lift_answers.map((answer, index) => {
                  return (
                    <Text size={12} ml={40} mt={2} weight={400} key={index}>
                      - {answer.answer}
                    </Text>
                  );
                })}
              </>
            )}
                      
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: 20,
              }}
            >
              <Exchange
                style={{
                  background: "#228BE6",
                  padding: 8,
                  borderRadius: 5,
                }}
                size={28}
                color="white"
              />
              <Text size="15px" ml={10} weight="600">
                In Return, You'll Get This
              </Text>
            </div>
            <Text size={12} ml={40} weight={400}>
              €
              {(
                props?.details?.streamers?.invoice /
                props?.details?.number_of_streams
              ).toFixed(1)}{" "}
              per sponsored stream, €{props?.details?.streamers?.invoice} in
              total.
            </Text>
            <Text size={12} ml={40} mt={5} weight={400}>
              You will need to take care of social fees and other taxes on your
              own.
            </Text>
            <Text size={12} ml={40} mt={5} weight={400}>
              The amount will be paid when we’ve confirmed that you’ve followed
              all the guidelines.
            </Text>
            <Text size={12} ml={40} mt={5} weight={400}>
              Please allow up to 30 days to receive your payment.
            </Text>
          
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: 25,
                minWidth: "40vw",
              }}
            >
              <InfoCircle
                style={{
                  background: "#228BE6",
                  padding: 8,
                  borderRadius: 5,
                }}
                size={28}
                color="white"
              />
              <Text size="15px" ml={10} weight="600">
                Talking Points (Optional)
              </Text>
            </div>
            <Text size={12} ml={40} weight={400}>
              Use this to tell your audience about {props?.details?.brand}
            </Text>
            {props?.details?.talking_points.map((talkingPoint) => {
              return (
                <Text size={12} mt={5} ml={40} weight={400}>
                  - {talkingPoint?.talkingPoint}
                </Text>
              );
            })}
            <div style={{display:"flex", justifyContent:"end", marginTop: 20, marginRight: 40}}>
            <Button size="xs" variant="outline" onClick={()=>{props.setOpened(false)}}>Close Brief</Button>
            </div>
          </Card>
        </div>
      </motion.div>
    </>
  );
}

export default SelectedCampaign;
